const INBOX = 'INBOX';

export const COOKIE_NAMES = new Map([
    ['SHOW_SENSITIVE_WORDS_WARNING', 'showSensitiveWordsWarning'],
]);

export const ROUTER_PAGES = ['mailList', 'message', 'message-sent', 'compose'];

export const ENDPOINTS = {
    DRAFT_SAVE: '/draft/save',
    COMPOSE_SEND: 'compose/send',
    MANAGE_SIGNATURES: '/options/signature',
    // For MAPI based version
    OPEN_FOLDER: '/mailbox?mailbox=',
    // Check/request pop3 pass in "Options"
    POP3_PASS: 'user/pub/pop3pass',
    SAVE_TO_FILES: 'api/v2/upload/urls',
    SAVE_TO_FOTO: 'controller/api/v1/upload/save?from_urls=true',
    SAVE_TO_FILES_ALL: '/attachment/save_to_files'
};

export const STORAGE_KEY_NAMES = {
    BYPASS_MAPI_CACHE: 'bypassMapiCache',
    COMPOSE_CACHE: 'compose-cache',
    COMPOSE_CACHE_CSRF_TOKEN: 'compose-cache_csrf-token',
    FOLDERS_LIST: 'folders-list',
};

export const ATTACHMENTS = {
    CLICK_ACTIONS: {
        'ADD_TO_CONTACTS': 'add-to-contacts',
        'DOWNLOAD_ALL': 'download-all',
        'DOWNLOAD': 'download-item',
        'PLAY': 'play-item',
        'SAVE_TO_CONTACTS': 'save-to-contacts',
        'SAVE_TO_FILES_ALL': 'save-to-files-all',
        'SAVE_TO_FILES': 'save-to-files',
        'SAVE_TO_FOTO': 'save-to-foto',
        'VIEW_AS_GRID': 'view-as-grid',
        'VIEW_CALENDAR': 'view-calendar',
        'VIEW_IMAGE': 'view-image',
        'VIEW_PDF': 'view-pdf',
        'VIEW_ZIP': 'view-zip',
    },
    FILE_ACTIONS: {
        // DISPLAYABLE: ['jpeg', 'jpg', 'png', 'gif'],
        PLAYABLE: ['mp4', 'mp4a', 'm4a', 'ogv', 'webm', 'mp3', 'm3u8', 'mpd', 'wav'],
        // Show thumbnail only
        // Reference: https://jira.dev.inbox.lv/browse/MAIL-4128
        SHOW_THUMBS_ONLY: ['ico', 'tiff', 'dng'] // MAIL-6337 - 'psd' should be as file, not image
    },
    GRID: {
        // Extra small devices Phones (<768px)
        xs: {
            cols: 1,
            th: 294,
            tw: 294,
            panelWidth: 'auto'
        },
        //  Small devices Tablets (≥768px)
        sm: {
            cols: 3,
            th: 244,
            tw: 244,
            panelWidth: 750
        },
        // Medium devices Desktops (≥992px)
        md: {
            cols: 4,
            th: 238,
            tw: 238,
            panelWidth: 970
        },
        // Large devices Desktops (≥1200px)
        lg: {
            cols: 5,
            th: 231,
            tw: 231,
            panelWidth: 1170
        }
    },
    THUMBNAIL: {
        H: 300,
        W: 300
    },
    VIEW_MODE: {
        GRID: 'grid',
        INLINE: 'inline'
    },
    // MAIL-6141 - TYPE_COLOR global colors are deleted (what was made for new compose attachments) now using css global vars
};

export const BREAKPOINTS = {
    // Extra small devices (phones)
    xs: 0,
    // Small devices (tablets)
    sm: 720,
    // sm: 768,
    // Medium devices (desktops)
    md: 992,
    // Large devices (large desktops)
    lg: 1200,
};

export const BATCH_ACTIONS = {
    'ACTION_DELETE': 2,
    'ACTION_FLAG': 3,
    'ACTION_MOVE': 1
};

// Options > Filters page
export const FILTERS = new Map([
    ['ACTION_NAMES', {
        CLOSE_EDITOR: 'close-editor',
        CREATE: 'create-filter',
        DELETE: 'delete-filter',
        EDIT: 'edit-filter',
        LIST_FILTERS: 'list-filters',
        MOVE_DOWN: 'move-down-filter',
        MOVE_UP: 'move-up-filter',
        SAVE: 'save-filter',
    }]
]);

export const FOLDERS_MANAGER = {
    ACTION_NAMES: {
        'CREATE': 'folder-create',
        'DELETE': 'folder-delete',
        'OPEN': 'folder-open',
        'PURGE': 'folder-purge',
        'RENAME': 'folder-rename',
        'FILTERS': 'filters-open',
    }
};

export const LABELS_MANAGER = {
    ACTION_NAMES: {
        'CREATE': 'label-create',
        'DELETE': 'label-delete',
        'RENAME': 'label-rename',
    }
};

/*
    Link Proxy responses and report types
    Exception 'INSPAM' - not hadled by link proxy
*/
export const LINK_PROXY = {
    STATUS_LIST: {
        AUTO: 'auto',
        BLACK: 'black',
        INVALID: 'invalid',
        SUSPICIOUS: 'suspicious',
        WHITE: 'white',
        INSPAM: 'inSpamFolder',
        OPINION: 'opinion',
    },
};

export const MAIL = new Map([
    ['ACTIONS', {
        ADD_TO_CONTACTS: 'add-to-contacts',
        BLOCK_SENDER: 'block-sender',
        CANCEL_EML: 'eml-cancel',
        CLOSE_EML: 'eml-close',
        CLOSE_POPUP_WIN: 'close-popup-window',
        COMPOSE_EML: 'eml-compose',
        COPY_TO_CLIPBOARD: 'eml-copy-to-clipboard',
        ENABLE_2FP: 'enable-2f-protection',
        FILTER_EML: 'eml-filter',
        FORWARD: 'forward',
        GO_CONTACTS: 'contacts',
        GO_FILES: 'files',
        GO_NEWS: 'news',
        GO_PORTAL: 'home',
        MARK_AS: 'mark-as',
        MARK_NOT_SPAM: 'mark-not-spam',
        MARK_SPAM: 'mark-as-spam',
        MOVE_TO: 'move-to',
        PRINT: 'print',
        PROMO_MAIL_PLUS: 'mail-plus-promo',
        PURCHASE_MAIL_PLUS: 'mail-plus-purchase',
        PURGE: 'purge',
        REDIRECT: 'redirect',
        REPLY_ALL: 'reply-to-all',
        REPLY: 'reply',
        SAVE_EML: 'eml-save',
        SEARCH_EML: 'eml-search',
        SEND_EML: 'eml-send',
        TRASH: 'trash',
        UNSUBSCRIBE: 'unsubscribe',
        VIEW_SOURCE: 'view-source',
        DOWNLOAD_EML: 'download-eml',
    }],
    ['DATE_FORMATS', {
        'default': {
            year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
        },
        'forEmlCompose': {
            weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false
        },
        'hour': { hour: 'numeric', minute: '2-digit', hour12: false },
        'long': {
            year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', weekday: 'long'
        },
        'short': { year: 'numeric', month: '2-digit', day: '2-digit' }
    }],
    ['FLAGS', (() => {
        const NAMES = new Map([
            ['ANSWERED', 'answered'],
            ['DRAFT', 'draft'],
            ['FLAGGED', 'flagged'],
            ['FORWARDED', 'forwarded'],
            ['SEEN', 'seen'],
            // Mapi does not use a flag for the unseen messages,
            // so define locally this just for visual purposes
            ['UNSEEN', 'unseen']
        ]);
        const COLORS = new Map([
            ['default', '#cccccc'],
            [NAMES.get('ANSWERED'), '#109b2a'],
            [NAMES.get('FLAGGED'), '#FFC700'],
            [NAMES.get('FORWARDED'), '#9340ab'],
            [NAMES.get('UNSEEN'), '#2d73d0'],
        ]);
        const LIST = [...NAMES.values()];

        return { COLORS, LIST, NAMES };
    })()],
    ['HEADER_FIELDS', { FROM: 'from', TO: 'to', CC: 'cc', BCC: 'bcc', SUBJECT: 'subject' }],
    ['HEADER_NAMES', ['from', 'replyTo', 'to', 'cc', 'bcc']],
    ['SYSTEM_DIRS', {
        INBOX: INBOX,
        DRAFT: `${INBOX}/draft`,
        LISTS: `${INBOX}/lists`,
        SENT: `${INBOX}/sent`,
        SOCIAL: `${INBOX}/social`,
        OUTBOX: `${INBOX}/outbox`,
        SPAM: `${INBOX}/spam`,
        TRASH: `${INBOX}/trash`
    }],
    ['COMPOSE', {
        ACCEPTED_MAILTO_FIELDS: {
            TO: 'to', CC: 'cc', BCC: 'bcc', SUBJECT: 'subject', BODY: 'body', CONTACT_LIST_ID: 'contactListId'
        },
        MODE_NAMES: {
            COMPOSE: 'compose',
            COMPOSE_SEND: 'compose/send',
            DRAFT: 'draft',
            DRAFT_SEND: 'draft/send',
            FORWARD: 'forward',
            FORWARD_SEND: 'forward/send',
            REPLY: 'reply',
            REPLY_ALL: 'reply/all',
            REPLY_SEND: 'reply/send',
        },
        // For the cases when the compose page is openend from Inbox Contacts
        TYPE_NAMES: {
            TO_ADDRESSES: 'contactListId',
            TO_GROUP: 'toGroup',
        },
        PREFS: {
            SAVE_SENT_COPY: 'save-sent-copy',
            REQUEST_READ_RECEIPT: 'request-read-receipt',
        },
    }],
]);

// XXX: use MAIL namespace
export const MAIL_FLAGS = MAIL.get('FLAGS');
export const MAIL_SYSTEM_DIRS = MAIL.get('SYSTEM_DIRS');

// react-query client options
export const QUERY_CLIENT_OPTIONS = new Map([
    ['DEFAULT', {
        defaultOptions: {
            queries: { refetchOnWindowFocus: false },
        },
    }]
]);

export const REACT_QUERY_NAMES = new Map([
    ['FOLDERS_LIST-FULL', 'folders-list-full'],
    ['FOLDERS_LIST-ONLY', 'folders-list-only'],
    ['HAS-RECENT-IN-FOLDERS', 'has-recent-in-folders'],
    ['MAIL-LIST', 'mailList'],
    ['LINK_PROXY_INIT', 'link-proxy-init'],
    ['LINK_PROXY_REPORT', 'link-proxy-report'],
    ['SINGLE-MAIL-DATA', 'single-mail-data'],
    ['USER_QUOTA_INFO', 'user-quota-info'],
]);

// Based on Inbox old file extensions ext.csv file
export const EXTENSIONMAP = {
    'BsFileEarmarkLock2': 'edoc, asice',
    'FaCss3': 'css',
    'FaFont': 'woff, ttf',
    'BsFiletypeHtml': 'cfm, mhtm, mhtml, htm, html',
    'FaRegAddressCard': 'vcf',
    'FaRegCalendarAlt': 'ics',
    'FaRegEnvelope': 'eml',
    'FaRegFileArchive': 'arj, r00, r01, r02, r03, rar, tar, tgz, zip, zz',
    'FaRegFileAudio': 'aac, aif,  iff, m3u, mid, midi, mp3, mp4a, m4a, mpa, ra, ram, wav, wma',
    'FaRegFileExcel': 'xls, xlt, xla, xlsx, xlsm, xlsb',
    'FaRegFileImage': 'bmp, jpeg, jpg, dib, jpe, jfif, gif, tif, tiff, png, 3dm, 3dmf,drw, dxf, raw',
    'FaRegFilePdf': 'pdf',
    'FaRegFilePowerpoint': 'ppt, pptx, ppsx, potx, potm, pptm',
    'FaRegFileVideo': 'avi, wmv, 3gp, mov, mp4, qt, rm, swf, dvr-ms, mpe, mpg, mpeg, m1v, vob, divx',
    'FaRegFileWord': 'docx, docm, dotx, dotm, doc, dot, odt, xps,  xml, wps',
    'FaRegFileAlt': 'txt',
    // Not used
    /*
    'actionscript.gif':  'as',
    'adobe.gif':         'psd, ai, dcs, eps, indd, mng, pct, svg, pgm, pbm, pnm',
    'c.gif':             'c, csh',
    'cd.gif':            'c2d, ccd, cd, cda, cdr, cidb, cif, cld, cue, iso, dmg, toast, vcd, mdf, md1, md2, nrg',
    'coldfusion.gif':    'cfm,',
    'compressed.gif':    'cmz, cp9, cpc, cpgz, cpt, crz, cso, c00, c01, c02, car, cbr, cbz',
    'cplusplus.gif':     'cpp, cc',
    'csharp.gif':        'cs',
    'database.gif':      'db, db2, dbc, dbf, dbk, dbt, dbv, dct, dcx, dgb, dp1, dsk, dwg',
    'flash.gif':         'fla, flp, flv, fpx, frs',
    'freehand.gif':      'ascii, targa, wmf, emf, dcs,',
    'link.gif':          'link, linx',
    'mac.gif':           'apm, cpt, dd, dir, hqx, saver',
    'office.gif':        'vsd, vss, vst, vsw,  mpp, mpd, mpt, mpw, mpx, pub, puz, mdb, accdb, maf, mam, maq, mar, mat, pub, puz, odt, ods, odp, odg, odf',
    'paintbrush.gif':    'pcx, pcc, pdv,',
    'php.gif':           'php',
    'text.gif':          'txt, rtf, log, wpd, djvu',
    'visualstudio.gif':  'sln, suo',
    */
};

export const MAPI = (() => {
    const fieldNames = new Map([
        ['ARRIVAL', 'ARRIVAL'],
        ['DISPLAYFROM', 'DISPLAYFROM'],
        ['SUBJECT', 'SUBJECT'],
        ['SIZE', 'SIZE'],
    ]);

    const WORDS = new Map([
        ['REVERSE', 'REVERSE'],
        ['UNSEEN', 'UNSEEN']
    ]);

    return {
        WORDS,
        FIELD_LIST: Array.from(fieldNames.values()),
        FIELD_MAP: fieldNames,
    };
})();

export const DEFAULT_TITLE = 'Inbox Mail';
export const SORT_OPTIONS = { arrival: 0, size: 3 };
export const STATUS_CODE = { unauthorized: 401 };
